import Pocetna from './components/Pocetna.vue'
import Popis_Novosti from './components/Popis_Novosti.vue'
import Novosti from './components/Novosti.vue'
import Prirucnici from './components/Prirucnici.vue'

export const routes = [
    { path: '', component: Pocetna },
    { path: '/novosti', component: Popis_Novosti },
    { path: '/prirucnici', component: Prirucnici },
    { path: '/novosti/:alias', component: Novosti },
]